<template>
  <div class="head">
    <img src="../assets/logo.png">
    <span>
      <el-dropdown @command="handleCommand" style="top: -15px;">
        <span class="el-dropdown-link">
          <img :src='img'>
          {{name}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="loginout">
            <i data-v-9e7bdc8e="" class="iconfont icon-tuichudenglu"></i>
            退出登录
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      
    </span>
  </div>
</template>

<script>
export default {
  props:{
    
  },
  data () {
    return {
      img:'',
      name:'',
      down:true
    }
  },
  components:{

  },
  mounted(){
    var _this = this;
    this.$http.post(api.user_selectssinfo).then(function(res){
        if(res.data.code == 100001){
            _this.img = res.data.data[0].avatar;
            _this.name = res.data.data[0].mobile;
        };      
    })

  },
  methods: {
    handleCommand(command) {
      var _this = this;
      if(command == 'loginout'){
        this.$confirm('是否退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.post(api.user_loginOut).then(function(res){
            if(res.data.code == 100001){
              _this.$message({type: 'success',message: '退出成功!'});
              setTimeout(()=>{
                _this.$router.push('/')
              },1200)
                
            }else{
              _this.$message.error(res.data.message);
            };
          })
        }).catch(() => {
                   
        });
      }else{
        
      }
    }
     
  }
}



</script>

<style scoped >

.head{
  background:#2fb8c2;
  padding:0 3%;
  box-sizing: border-box;
  height: 80px;
}
.head span{
  float:right;
  padding:15px 0;
  font-size: 1.5rem;
  height: 80px;
  box-sizing: border-box;
}
.head span img{
  width:50px;
  height:50px;
  border-radius:50%;
  vertical-align: middle;
}
.select{
  position: relative;
  top: 5px;
}
.select li{
  text-align: center;
  border-bottom: 1px solid #d3d3d3;
  font-size: 1rem;
  line-height: 3rem;
}

</style>



// WEBPACK FOOTER //
// src/common/head.vue